<template>
    <div class="van-cell-group van-hairline--top-bottom">
      <div class="van-cell van-cell--borderless van-field">
        <div class="van-cell__title van-field__label">
          <span>{{label}}</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body" v-if="disabled" style="width: 92%">
            <input type="text" disabled :placeholder="placeholder" :value="value" class="van-field__control van-field__control--right"></input>
            <i v-if="disabled" class="el-icon-arrow-right arrow-right"></i>
          </div>
          <div class="van-field__body" v-if="!disabled">
            <input type="text" :placeholder="placeholder" @input="$emit('input',$event.target.value)" :value="value" class="van-field__control van-field__control--right"></input>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
      data(){
        return{

        }
      },
      props:{
        //左侧标题
        label:{
          type:String
        },
        //输入框的值
        value:{
          type:String
        },
        //输入框默认文字
        placeholder:{
          type:String
        },
        //是否禁用
        disabled:{
          type:Boolean,
          default:false
        }
      }
    }
</script>

<style scoped>
  @import "../../../static/css/vant.css";
  .arrow-right{
    position: absolute;
    right: 0;
    color: #969799;
    font-size: .32rem;
    font-weight: 900;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Cell.vue